import { useState } from 'react';
import { NSButton } from 'bricks';
import { downloadFileFromUrl } from 'helpers/file/download';
import useToast, { ToastType } from 'hooks/useToast';
import { getExtractedProFormaExecutiveSummaryPdf } from 'queries/ExtractedProForma';
import {
    DOWNLOADING_PDF_TOAST, EXPORT_PDF_FILE_SUFFIX, PDF_DOWNLOADED_TOAST, PDF_DOWNLOAD_FAILED_TOAST,
} from './constants';

export interface ExtractedProFormaExportButtonProps {
    organizationId: string;
    dealId: number;
    extractedProFormaId: number;
    dealName: string;
}

const ExtractedProFormaExportButton = ({
    organizationId, dealId, extractedProFormaId, dealName,
}: ExtractedProFormaExportButtonProps) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const { showToast } = useToast();

    const exportExecutiveSummaryPdf = async () => {
        setIsDownloading(true);
        const toastId = showToast(DOWNLOADING_PDF_TOAST, ToastType.Success, { autoClose: false });
        try {
            const { url } = await getExtractedProFormaExecutiveSummaryPdf({ organizationId, dealId, extractedProFormaId });
            await downloadFileFromUrl(url, `${dealName}${EXPORT_PDF_FILE_SUFFIX}`, 'pdf', true);
            showToast(PDF_DOWNLOADED_TOAST, ToastType.Success, undefined, toastId);
        } catch {
            showToast(PDF_DOWNLOAD_FAILED_TOAST, ToastType.Error, undefined, toastId);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <NSButton
            color="primary"
            outline
            className="mr-2"
            text="Export"
            callback={exportExecutiveSummaryPdf}
            disabled={isDownloading}
            allowReadOnlyAccess
        />
    );
};

export default ExtractedProFormaExportButton;
